import './AgendaToast.styles.scss';
import { BellIcon, XMarkIcon } from '@heroicons/react/16/solid';
import moment from 'moment';
import { tAgendaEventNotificationProps } from '../../Notification.types.ts';
import { useNotificationsContext } from '../../Notifications.constants.ts';

export default function AgendaToast(props: tAgendaEventNotificationProps) {
  const { notification } = props;
  const { closeNotification } = useNotificationsContext();

  const date = moment(notification?.notification?.start_date ?? '').format(
    'hh:mm A',
  );

  const minutes = notification.notification.reminder_time_minutes;

  const notificationText = minutes
    ? `Tu evento es a las ${date}. Comienza en ${minutes} minutos`
    : `Tu evento es a las ${date}`;

  return (
    <div className="AgendaToast">
      <div className="AgendaToast__header">
        <div className="flex flex-row items-center">
          <BellIcon className="AgendaToast__Icon" />
          {notification.notification.name}
        </div>
        <XMarkIcon
          className="AgendaToast__CloseIcon"
          onClick={() => closeNotification(notification.id)}
        />
      </div>
      <p className=" text-sm">{notificationText}</p>
    </div>
  );
}
